<template>
  <div class="d-contents spacey-24">
    <Checkbox
      :checked="form.is_supplies_materials_only"
      @check="updateFormValue({ key: 'is_supplies_materials_only', value: $event })"
    >
      {{ $t('This company supplies materials only') }}
    </Checkbox>
    <div class="spacey-16">
      <div class="text-h3">{{ $t('Works they perform') }}</div>
      <FormInput
        id="search-types-of-work"
        v-model="workSearchText"
        :placeholder="$t('Search types of work...')"
      />
      <div class="spacey-12">
        <template v-for="work in computedWorkGroups">
          <Accordion
            v-if="work.works.length"
            :key="work.id"
            :title="`${work.number}. ${work.title}`"
            :content="work.works"
            :counter="getCountOfSelectedWorks(work.works)"
            :selected-element-ids="form.works"
            @check="checkWorkHandler"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import Checkbox from '@/components/ui/Checkbox';
  import FormInput from '@/components/ui/FormInput';
  import Accordion from '@/components/ui/Accordion';
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'ContractorsWorksTab',
    components: { Accordion, FormInput, Checkbox },
    data() {
      return {
        workSearchText: '',
        isSuppliesMaterialsOnly: false,
      };
    },
    computed: {
      ...mapState('contractors', ['workGroups', 'form']),
      computedWorkGroups() {
        const computedWorkGroups = [];
        for (let workGroup in this.workGroups) {
          const computedWorks = [];
          const works = this.workGroups[workGroup].works;
          for (let work in works) {
            if (works[work].title.toLowerCase().includes(this.workSearchText.toLowerCase())) {
              computedWorks.push({
                id: work,
                slug: work,
                number: works[work].number,
                title: works[work].title,
              });
            }
          }
          computedWorkGroups.push({
            id: workGroup,
            number: this.workGroups[workGroup].number,
            slug: workGroup,
            title: this.workGroups[workGroup].title,
            works: computedWorks,
          });
        }
        return computedWorkGroups;
      },
    },
    methods: {
      ...mapActions('contractors', ['updateFormValue']),
      checkWorkHandler({ value, id }) {
        if (value) {
          this.updateFormValue({ key: 'works', value: [...this.form.works, id] });
        } else {
          this.updateFormValue({
            key: 'works',
            value: this.form.works.filter((elem) => elem !== id),
          });
        }
      },
      getCountOfSelectedWorks(works) {
        let count = 0;
        works.forEach((work) => {
          if (this.form.works.includes(work.id)) {
            count++;
          }
        });
        return count;
      },
    },
  };
</script>
